import apiInlandCompanies from '../../api/apiInlandCompanies'

const state = {
    companies: [],
    selectedCompany: {},
    isLoading: false,
}

const getters = {
    getInlandCompanies: (state) => {
        return state.companies
    },
    getSelectedInlandCompany: (state) => {
        return state.selectedCompany
    },
    getInlandCompanyLoadingStatus: (state) => {
        return state.isLoading
    }
}

const mutations = {
    changeInlandCompanies: (state, newValue) => {
        state.companies = newValue
    },
    changeSelectedInlandCompanyFieldValue: (state, priceInput) => {
        state.selectedCompany[priceInput.field] = priceInput.value
    },
    changeSelectedInlandCompany: (state, newValue) => {
        state.selectedCompany = newValue
    },
    changeInlandCompaniesLoadingStatus: (state, newValue) => {
        state.isLoading = newValue
    }
}

const actions = {
    setInlandCompanyFieldValue: ({ commit }, priceInput) => {
        commit('changeSelectedInlandCompanyFieldValue', priceInput)
    },
    setSelectedInlandCompany: ({ commit }, newValue) => {
        commit('changeSelectedInlandCompany', newValue)
    },
    fetchAllInlandCompanies: ({ commit }) => {
        commit('changeInlandCompaniesLoadingStatus', true)
        apiInlandCompanies
            .inlandCompaniesListRequest()
            .then((response) => {
                commit('changeInlandCompanies', response.data)
                commit('changeInlandCompaniesLoadingStatus', false)
            })
    },
    updateInlandCompany: ({ commit, getters, dispatch }) => {
        commit('changeInlandCompaniesLoadingStatus', true)
        apiInlandCompanies
            .updateInlandCompanyRequest(getters.getSelectedInlandCompany)
            .then((response) => {
                commit('changeInlandCompaniesLoadingStatus', false)
                dispatch('setSelectedInlandCompany', {})
                dispatch('fetchAllInlandCompanies')
            })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/inlandCompanies.js